// extracted by mini-css-extract-plugin
export default {"close":"create-warehouse_close__fDlAw","container":"create-warehouse_container__tN7fL","steps":"create-warehouse_steps__TxFNM","drag":"create-warehouse_drag__ba_Ug"};